import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Input } from 'antd';
import ExecutorsTypes from './ExecutorsTypes';
const Search = Input.Search;

const TopPanel = props => {
  const {
    typesList,
    totalExecutors,
    onChangeTypeList,
    onChangeSearch,
    handleSearchExecutors,
    searchValue,
    typeListValue,
    stat,
  } = props;

  return (
    <div className="b-table-filters">
      <Row>
        <Col span={18}>
          <div className="orders__states">
            <ExecutorsTypes
              totalExecutors={totalExecutors}
              typesList={typesList}
              stat={stat}
              value={typeListValue}
              onChangeTypeList={onChangeTypeList}
            />
          </div>
        </Col>
        <Col span={6}>
          <Search
            placeholder="Поиск по исполнителям"
            onChange={onChangeSearch}
            value={searchValue}
            allowClear={true}
            onSearch={handleSearchExecutors}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default connect(state => ({
  searchValue: state.Executors.Filters.search,
  typeListValue: state.Executors.Filters.typeList,
}))(TopPanel);
